import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  CART_ITEM_ADDED,
  CART_ITEM_CLEARED,
  CART_ITEM_RECEIVED,
  CART_ITEM_REMOVED,
  CLEAR_PROMO_DETAIL,
  FINAL_CART_ITEM_ADDED,
  PRODUCT_CATEGORY_LIST_RECEIVED,
  PRODUCT_ITEM_REMOVED,
  PRODUCT_ITEM_UPDATED,
  PRODUCT_LIST_RECEIVED,
  PROMO_CODE_APPLIED,
} from "../constants/types/cartType";
import axios from "../utils/axios";

import { appLoading } from "./alertAction";

export const addCartItem = (item, callback) => (dispatch) => {
  dispatch({
    type: CART_ITEM_ADDED,
    payload: item,
  });
  callback && callback();
};

export const addFinalCartItem = (item, callback) => (dispatch) => {
  dispatch({
    type: FINAL_CART_ITEM_ADDED,
    payload: item,
  });
  callback && callback();
};

export const clearCartItems = () => (dispatch) => {
  dispatch({
    type: CART_ITEM_CLEARED,
    payload: null,
  });
};

export const removeItemFromCart = (item) => (dispatch) => {
  dispatch({
    type: CART_ITEM_REMOVED,
    payload: item,
  });
};

export const removeProductFromCart = (item) => (dispatch) => {
  dispatch({
    type: PRODUCT_ITEM_REMOVED,
    payload: item,
  });
};

export const updateProductFromCart = (id, qty) => (dispatch) => {
  dispatch({
    type: PRODUCT_ITEM_UPDATED,
    payload: { id, qty },
  });
};

export const clearPromoDetail = () => (dispatch) => {
  dispatch({
    type: CLEAR_PROMO_DETAIL,
    payload: null,
  });
};

export const applyPromoCode = (code) => (dispatch) => {
  axios.get(`promoCode?action=checkPromoCode&promo_code=${code}`).then(
    (resp) => {
      if (resp.data?.result === "success") {
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
        dispatch({
          type: PROMO_CODE_APPLIED,
          payload: resp.data,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getCartItems = (roleId, callback) => (dispatch) => {
  if (roleId > 0) {
    roleId = roleId == 3 ? roleId : roleId == 4 ? roleId : 1;
    axios.get(`cart?action=getUserCartList&roleId=${roleId}`).then(
      (resp) => {
        if (resp.data?.result === "success") {
          dispatch({
            type: CART_ITEM_RECEIVED,
            payload: resp.data.cartItems,
          });
          callback && callback();
        } else {
          dispatch({
            type: ERROR,
            payload: resp.data.error,
          });
          callback && callback();
        }
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
        callback && callback();
      }
    );
  } else {
    callback && callback();
  }
};

export const getProductList = (callback) => (dispatch) => {
  axios.get(`product?action=getProductList`).then(
    (resp) => {
      if (resp.data?.result === "success") {
        dispatch({
          type: PRODUCT_LIST_RECEIVED,
          payload: resp.data.products,
        });
        callback && callback();
      } else {
        dispatch({
          type: PRODUCT_LIST_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get prodduct list.",
      });
      callback();
    }
  );
};

export const getProductCategoryList = (callback) => (dispatch) => {
  axios.get(`product?action=getCategoryList`).then(
    (resp) => {
      if (resp.data?.result === "success") {
        dispatch({
          type: PRODUCT_CATEGORY_LIST_RECEIVED,
          payload: resp.data.categoryList,
        });
        callback && callback();
      } else {
        dispatch({
          type: PRODUCT_CATEGORY_LIST_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
        callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to get prodduct list.",
      });
      callback();
    }
  );
};

export const cartPostAction = (data, callback) => (dispatch) => {
  axios.post("cart", data).then(
    (resp) => {
      if (resp.data?.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const orderItem = (data, callback) => (dispatch) => {
  dispatch(appLoading(true));
  axios.post("ordersPatient", data).then(
    (resp) => {
      if (resp.data?.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      dispatch(appLoading(false));
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      dispatch(appLoading(false));
    }
  );
};
